import React, { useEffect, useState } from "react";
import svg from "../assets/img/wave-haikei (3).svg";
import Playlist from "../Component/Playlist/Playlist";
import "./Hero.css";
import WriteBlog from "./WriteBlog/WriteBlog";
const Hero = () => {
  const [ChannelInfo, setChannelInfo] = useState([]);
  useEffect(() => {
    fetch(
      "https://youtube.googleapis.com/youtube/v3/channels?part=snippet&id=UC49igY3A_M9__UL4_QUWTBA&key=AIzaSyBaQ3qRfrim14hAzutqHtPUR-Oq-_jhNSg"
    )
      .then((res) => res.json())
      .then((data) => setChannelInfo(data?.items[0]?.snippet));
  }, []);

  return (
    <>
      <div className="hero hero-style pt-10">
        <div className="hero-content text-center pb-10">
          <div className="flex flex-col items-center md:w-1/2 ">
            <img
              width={"200px"}
              className="mask mask-circle"
              alt="Channel-logo"
              src={ChannelInfo?.thumbnails?.medium?.url}
            />
            <h1 className="text-5xl font-bold text-black">
              {ChannelInfo?.title}
            </h1>
            <p className="py-6 text-slate-700">
              {ChannelInfo?.description?.slice(0, 298)}
            </p>
            {/* ------------------------- */}

            <div className="pt-2 pb-1 px-3 rounded-lg bg-white">
              <div
                className="g-ytsubscribe"
                data-channelid="UC49igY3A_M9__UL4_QUWTBA"
                data-layout="default"
                data-count="default"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <img src={svg} alt="" />
      {/* ---------------------------- */}

      <div className="flex flex-col w-3/4 lg:flex-row my-10 mx-auto gap-8">
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-violet-400 font-semibold text-2xl text-white">
          Technologies
        </div>
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-fuchsia-400 font-semibold text-2xl text-white">
          Information
        </div>
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-indigo-400 font-semibold text-2xl text-white">
          Security
        </div>
      </div>
      <Playlist></Playlist>
      <WriteBlog></WriteBlog>
      {/* <Videos></Videos> */}
    </>
  );
};

export default Hero;
